import React, { Component } from 'react'
import HeatMapItem from './HeatMapItem'
import { withRouter } from "react-router"

export class HeatMapFamily extends Component {


  style = {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      borderStyle: 'solid',
      borderWidth: '1px',
      marginTop: '0.1in',
      marginBottom: '0.1in',
      padding: '0.1in 0.2in',
      borderRadius: '20px',
      borderColor: '#006595',
    },

    family: {
      width: '25%'
    },

    spacer: {
      width: '5%'
    },

    data: {
      width: '70%'
    },

    xLarge: {
      fontSize: 'x-large'
    },

  }


  render() {
    const { family } = this.props.familyData

    return (

      <div className= "no-break-print" style={ this.style.container }>
        <div style={ this.style.family }>
          <div style={ this.style.xLarge }>
            { family }
          </div>
          <div style={ this.style.spacer } />
          <div>
            { this.props.header[this.props.familyData.family] }
          </div>
        </div>
        <div style={ this.style.data }>
          { this.props.familyData.data.map((item, index) =>
            <HeatMapItem name={ item.measurement }
                         value={ parseFloat(item.value) }
                         key={ index }
                         family={ family } />) }

        </div>

      </div>
    )
  }
}

export default withRouter(HeatMapFamily)